import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getBranches } from '../../redux/branchSlice';

function Categories() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { branches, loading } = useSelector((state) => state.branches);

  useEffect(() => {
    dispatch(getBranches());
  }, [dispatch]);

  const handleBranchClick = (branch) => {
    navigate(`/userPageDiscover?branch=${branch._id}`);
  };

  return (
    <div className="w-full h-full min-h-[160px] bg-white rounded-2xl shadow-md p-4 flex flex-col">
      <h2 className="text-sm sm:text-base font-poppins font-semibold text-text mb-3">
        {t('categories')}
      </h2>
      <div className="flex flex-wrap gap-2">
        {!loading && branches?.map((branch) => (
          <button
            key={branch._id}
            onClick={() => handleBranchClick(branch)}
            className="bg-white border border-[#625480] text-[#625480] text-xs px-3 py-1.5 rounded-full hover:bg-[#625480] hover:text-white transition-colors duration-200 font-poppins shadow-sm"
          >
            {branch.name}
          </button>
        ))}
      </div>
    </div>
  );
}

export default Categories;
